import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Features from "@/components/landing/Features";
import Trainer from "@/components/landing/Trainer";
import Pricing from "@/components/landing/Pricing";
import Faq from "@/components/landing/Faq";
import ContactCTA from "@/components/landing/ContactCTA";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="relative">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Trainer />
        <Pricing />
        <Faq />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
}
